import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
